import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* dampingCoefficientsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.DAMPING_COEFFICIENT_IN_CURRENT_BOARD_GET_OR_CREATE, () =>
      services.getOrCreateDampingCoefficientInCurrentBoard(),
    ),
    takeEvery(EntryActionTypes.DAMPING_COEFFICIENTS_IN_CURRENT_BOARD_FETCH, () =>
      services.fetchDampingCoefficientsInCurrentBoard(),
    ),
    takeEvery(EntryActionTypes.DAMPING_COEFFICIENT_CREATE, ({ payload: { pointSystemId, data } }) =>
      services.createDampingCoefficient(pointSystemId, data),
    ),
    takeEvery(EntryActionTypes.DAMPING_COEFFICIENT_UPDATE, ({ payload: { id, data } }) =>
      services.updateDampingCoefficient(id, data),
    ),
    takeEvery(EntryActionTypes.DAMPING_COEFFICIENT_DELETE, ({ payload: { id } }) =>
      services.deleteDampingCoefficient(id),
    ),
  ]);
}

